import React from 'react';
import styled from 'styled-components';
import loader from './loader.gif';

const LoaderContainer = styled.div`
  width: 100%;
  text-align: center;
`;
const StyledLoader = styled.img`
  width: 80px;
`;

const Loader = () => (
  <LoaderContainer>
    <StyledLoader src={loader} />
  </LoaderContainer>
);

export default Loader;
